import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Button from 'components.v2/Button'
import Text from 'components.v2/Text'
import OrderList from 'common/Order/OrderList'
import DiscountList from 'common/Order/DiscountList'
import withOrderContainer from 'pages/order/modules/withOrderContainer'
import ShadowScrollBox from 'components.v2/ShadowScrollBox'
import events from 'const/analytics-events'
import withAnalytics from 'enhancers/withAnalytics'

import {
  ordersToTotal,
  ordersToQty,
  discountToTotal,
} from 'pages/order/modules/order'

import { formatPrice } from 'utils/currency'

import { OrderBox, Description, OrderListContainer, Separator } from './styled'

const CheckoutButton = withAnalytics()(Button)

const Order = ({ selectedOrders, match, discounts, location }) => {
  const quantity = ordersToQty(selectedOrders)
  const ordersTotal = ordersToTotal(selectedOrders)
  const discountTotal = discountToTotal(discounts)
  const subtotal = ordersTotal + discountTotal
  const hasDiscount = discounts && !!discounts.length

  return (
    <OrderBox centered={selectedOrders.length === 0}>
      {selectedOrders.length === 0 ? (
        <div className="w-full px-15">
          <Text variant="h4" color="gray4" align="center">
            Your cart is empty
          </Text>
          <Description color="grey" align="center">
            Select something yummy from the menu and add it your order.
          </Description>
          <Button variant="whitelabel" disabled largeText>
            Go to checkout
          </Button>
        </div>
      ) : (
        <div style={{ width: '100%' }}>
          <Text variant="h4" className="mx-15 mb-20">
            Your order
          </Text>

          <ShadowScrollBox>
            <OrderListContainer className="px-15">
              <OrderList orders={selectedOrders} />
            </OrderListContainer>

            {hasDiscount && (
              <div className="mt-20">
                <DiscountList discounts={discounts} />
              </div>
            )}

            {!hasDiscount && <Separator />}
          </ShadowScrollBox>

          <div className="mx-15 my-20">
            {hasDiscount && (
              <div className="flex justify-between items-center">
                <Text variant="secondary" color="gray3">
                  Discount
                </Text>
                <Text variant="secondary" color="gray3">
                  -${discountTotal * -1}
                </Text>
              </div>
            )}

            <div className="flex justify-between items-center">
              <Text bold>
                Subtotal ({quantity} item{quantity > 1 ? 's' : ''})
              </Text>
              <Text>{formatPrice(subtotal)}</Text>
            </div>
          </div>

          <CheckoutButton
            className="mx-15"
            as={Link}
            to={`/order/${match.params.id}/review`}
            variant="whitelabel"
            analytics={[
              {
                eventType: 'onClick',
                options: {
                  ...events['MENU_CLICK_GO_TO_CHECKOUT'],
                  label: String(match.params.id),
                },
              },
            ]}
            largeText
          >
            Go to checkout
          </CheckoutButton>
        </div>
      )}
    </OrderBox>
  )
}

Order.propTypes = {
  selectedOrders: PropTypes.arrayOf(
    PropTypes.shape({
      quantity: PropTypes.number.isRequired,
    }),
  ).isRequired,
  discounts: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.string.isRequired,
    }),
  ).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default withOrderContainer()(Order)
